import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative my-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-0 flex items-center",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-300" })
], -1)
const _hoisted_3 = { class: "relative flex justify-start" }
const _hoisted_4 = { class: "bg-white pr-3 text-xl font-semibold leading-6 text-stone-700 font-serif" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DividerLabelLeft',
  props: {
	label: {
		type: String,
		required: true
	}
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(props.label), 1)
    ])
  ]))
}
}

})